import { createFileRoute, redirect } from '@tanstack/react-router';

import { isSignedIn } from '~/lib/auth-client';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    /** The work, not the configuration. Signing in is something a receptionist
     *  does at the start of a day; settings is somewhere you go on purpose. */
    throw redirect({ to: (await isSignedIn()) ? '/tasks' : '/sign-in' });
  },
});
